import React, { useEffect, useMemo, useRef } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';
import styles from './styles.styl';

function VideoElement({
  connection: { ready, video, stream } = {},
  className,
}) {
  const videoReady = useMemo(() => ready && video, [ready, video]);
  const noVideo = stream && !stream.hasVideo;
  const videoRef = useRef();

  useEffect(() => {
    if (videoReady) {
      videoRef.current.appendChild(video);
    }
  }, [videoReady]);

  return (
    <div
      className={cn(styles.video, className, { [styles.noVideo]: noVideo })}
      ref={videoRef}
    />
  );
}

VideoElement.propTypes = {
  connection: ConnectionShape,
  className: PropTypes.string,
};

export default VideoElement;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/MobileVideo/VideoElement/index.jsx